import { conversationSignal, type ConversationSignal } from '@/features/conversations/signal';
import type { Conversation } from './api';

/** The thread a site card speaks for: its most urgent live conversation, with who is on the other side. */
export interface LiveConversation {
  conversation: Conversation;
  signal: ConversationSignal;
}

/** Most urgent live conversation per location, keyed by each conversation's primary location. */
export function liveByLocation(items: readonly Conversation[]): Map<string, LiveConversation> {
  const out = new Map<string, LiveConversation>();
  for (const c of items) {
    const id = c.primary_location_id ?? c.locations[0]?.location_id;
    const signal = id ? conversationSignal(c) : null;
    if (!id || !signal) continue;
    const prev = out.get(id);
    if (!prev || signal.rank < prev.signal.rank) out.set(id, { conversation: c, signal });
  }
  return out;
}

/** Display name of the other side of a thread. */
export function counterpartName(c: Conversation): string {
  return c.counterpart?.name || c.counterpart?.email || c.latest_message?.sender_name || 'No correspondent';
}
